// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubProfileCard-cls1___1cf5d8cb5df97d3fc5d","cls2":"ImpactHubProfileCard-cls2___2a26a258040854ad51d ImpactHubProfileCard-cls1___1cf5d8cb5df97d3fc5d"};